import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { DASHBOARD } from "./dashboardTheme";

/** Keeps tile height stable while async metrics load. */
export function DashboardTileMetricPlaceholder({ minHeight = 88 }: { minHeight?: number }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        minHeight,
        mt: 1,
      }}
      aria-busy="true"
      aria-label="Loading"
    >
      <CircularProgress size={28} sx={{ color: DASHBOARD.accent }} />
    </Box>
  );
}
